export default "__VITE_ASSET__0ASO5eMc__"